import { Action } from '@ngrx/store';

export enum CitiesActionTypes {
  GET_CITIES = '[SHARED TOAST] Get Cities',
  GET_CITIES_SUCCESS = '[SHARED TOAST] Get Cities Success',
  GET_CITIES_ERROR = '[SHARED TOAST] Get Cities Error',
}

export class GetCities implements Action {
  readonly type = CitiesActionTypes.GET_CITIES;
}
export class GetCitiesSuccess implements Action {
  readonly type = CitiesActionTypes.GET_CITIES_SUCCESS;
  constructor(public payload: any) {}
}
export class GetCitiesError implements Action {
  readonly type = CitiesActionTypes.GET_CITIES_ERROR;
  constructor(public payload: any) {}
}

export type CitiesActions = GetCities | GetCitiesSuccess | GetCitiesError;
